import {
  EXPENSE_LOWERCASE_PAYEE,
  EXPENSE_PAID_WITH_SESSIONS,
} from "../expense-items/stubs";

import { generateMockChargeDetailRecord } from "./generators";
import type { ChargeDetailRecord } from "./generators";

const SESSION_WITH_MEASUREMENTS = generateMockChargeDetailRecord({
  transactionId: 770_101,
  startedAt: "2026-06-03T06:10:00.000Z",
  endedAt: "2026-06-03T09:55:00.000Z",
});

const SESSION_WITH_NO_MEASUREMENTS = generateMockChargeDetailRecord({
  transactionId: 770_102,
  startedAt: "2026-06-01T22:40:00.000Z",
  endedAt: "2026-06-02T04:05:00.000Z",
  locationName: "Odense Syd",
  consumedInWattHours: 24_900,
  amountInCents: 52_29,
});

const SESSION_WHOSE_CHART_FAILS = generateMockChargeDetailRecord({
  transactionId: 770_103,
  startedAt: "2026-06-05T11:05:00.000Z",
  endedAt: "2026-06-05T12:20:00.000Z",
  locationName: "Vejle Vest",
  consumedInWattHours: 9_100,
  amountInCents: 19_11,
});

const SESSION_SPANNING_TWO_DAYS = generateMockChargeDetailRecord({
  transactionId: 770_104,
  startedAt: "2026-06-02T14:30:00.000Z",
  endedAt: "2026-06-04T18:45:00.000Z",
  locationName: "Aalborg Ost",
  consumedInWattHours: 31_600,
  amountInCents: 66_36,
});

const SESSION_ON_LOWERCASE_PAYEE_ITEM = generateMockChargeDetailRecord({
  transactionId: 770_105,
  startedAt: "2026-06-08T07:00:00.000Z",
  endedAt: "2026-06-08T08:30:00.000Z",
});

const SEEDED_LINKED_CDRS: Record<string, ChargeDetailRecord[]> = {
  [EXPENSE_PAID_WITH_SESSIONS.id]: [
    SESSION_WITH_MEASUREMENTS,
    SESSION_WITH_NO_MEASUREMENTS,
    SESSION_WHOSE_CHART_FAILS,
    SESSION_SPANNING_TWO_DAYS,
  ],
  [EXPENSE_LOWERCASE_PAYEE.id]: [SESSION_ON_LOWERCASE_PAYEE_ITEM],
};

const FIRST_CANDIDATE_SESSION = generateMockChargeDetailRecord({
  transactionId: 770_106,
  startedAt: "2026-06-01T05:00:00.000Z",
  endedAt: "2026-06-01T07:30:00.000Z",
  locationName: "Candidate Site 1",
});
const SECOND_CANDIDATE_SESSION = generateMockChargeDetailRecord({
  transactionId: 770_107,
  startedAt: "2026-06-02T05:00:00.000Z",
  endedAt: "2026-06-02T07:30:00.000Z",
  locationName: "Candidate Site 2",
});

const FIRST_BULK_CANDIDATE_TRANSACTION_ID = 770_108;

const SEEDED_NON_LINKED_CDRS: ChargeDetailRecord[] = [
  FIRST_CANDIDATE_SESSION,
  SECOND_CANDIDATE_SESSION,
  ...Array.from({ length: 28 }, (_, index) => {
    const day = String(((index + 2) % 27) + 1).padStart(2, "0");
    return generateMockChargeDetailRecord({
      transactionId: FIRST_BULK_CANDIDATE_TRANSACTION_ID + index,
      startedAt: `2026-06-${day}T05:00:00.000Z`,
      endedAt: `2026-06-${day}T07:30:00.000Z`,
      locationName: `Candidate Site ${String(index + 3)}`,
    });
  }),
];

export {
  FIRST_CANDIDATE_SESSION,
  SECOND_CANDIDATE_SESSION,
  SEEDED_LINKED_CDRS,
  SEEDED_NON_LINKED_CDRS,
  SESSION_ON_LOWERCASE_PAYEE_ITEM,
  SESSION_SPANNING_TWO_DAYS,
  SESSION_WHOSE_CHART_FAILS,
  SESSION_WITH_MEASUREMENTS,
  SESSION_WITH_NO_MEASUREMENTS,
};
